@if (otherId) {
  <div
    [style.backgroundImage]="'url(' + imageUrl + ')'"
    #imageBox
    [id]="otherId"
    class="upload-image-box"
    [ngClass]="{ isDragging: isDragging }"
    >
    @if ((imageValue || imageUrl) && isEditing) {
      <i
        class="fa fa-fw fa-times delete"
        (click)="deleteImage()"
      ></i>
    }
    @if (!imageValue && !imageUrl && isEditing) {
      <div
        class="upload-box"
        tabindex="0"
        (click)="image.click()"
        (keyup.enter)="image.click()"
        (dragover)="onDragOver($event)"
        (dragleave)="isDragging = false"
        (drop)="imageDropped($event)"
        [style.width]="'100%'"
        [style.height]="'100%'"
        >
        @if (!imageValue && !imageUrl && isEditing) {
          <i class="fa fa-pen"></i>
        }
      </div>
    }
  </div>
}
<input
  #image
  type="file"
  accept="image/png, image/jpeg, image/gif, image/bmp, image/tiff, image/wbmp"
  class="d-none"
  (change)="imageUploadFromInput($event)"
  />
